export default "__VITE_ASSET__927aaebc__"